<template>
  <div class="choose-course">
    <Modal v-model="show" title="选择适用课程" :footer-hide="true" width="80">
      <div class="flex">
        <div class="left">
          <div class="search-line">
            <Input
              v-model="courseSearchData.classroomName"
              class="search-input"
              placeholder="请输入课程名称"
              clearable
            ></Input>
            <div class="flex align-items" style="margin-right: 8px">
              {{ yearTermStr }}
            </div>
            <choose-apply
              ref="chooseApplyRef"
              :placeholder="`全部课程提供方`"
              class="search-input"
              @on-change="handleOnApplyChange"
            ></choose-apply>

            <Select
              v-model="courseSearchData.classType"
              class="search-input"
              placeholder="资源类别"
              disabled
            >
              <Option
                v-for="item in courseTypeList"
                :key="item.id"
                :value="item.id"
              >{{ item.name }}</Option>
            </Select>
            <Button
              type="primary"
              style="margin-right: 8px"
              @click="handleGetSearchValue"
            >搜索</Button>
            <Button class="reset-btn" @click="handleResetSearch">重置</Button>
          </div>
          <div class="table">
            <Table
              ref="selection"
              border
              :columns="courseListColumn"
              :data="courseGoodsList"
              :loading="tableLoading"
              @on-select="onSelect"
              @on-select-cancel="onSelectCancel"
              @on-select-all="onSelectAll"
              @on-select-all-cancel="onSelectAllCancel"
              @on-selection-change="onSelectionChange"
            ></Table>
            <div class="page-main">
              <Page
                :total="coursePageInfo.total"
                show-total
                :current="coursePageInfo.pageNum"
                class="page-right"
                @on-change="handlePageChange"
              ></Page>
            </div>
            <!-- <div class="iconTips">
              <Icon
                type="md-alert"
                size="16"
                color="#ff9900"
                style="padding-right: 10px"
              ></Icon
              >商品选择范围不含圈定报名范围、预报名的课程商品
            </div> -->
          </div>
        </div>
        <div class="right">
          <div class="head">选中({{ selectCourseList.length }})</div>
          <div class="right-table">
            <Table
              :columns="rightColumns"
              border
              :data="selectCourseList"
              height="550"
            ><template slot="action" slot-scope="{ row, index }">
              <Button
                type="error"
                size="small"
                @click="handleRemove(row, index)"
              >删除</Button>
            </template></Table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <Button
          style="margin-right: 16px"
          @click="handleCancleBtn"
        >取消</Button>
        <Button type="primary" @click="handleSureBtn">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ChooseAndModal from '@c/ChooseAndModal.vue';

import courseCenter from '@/request/courseCenter/index.js';
import resources from '@/request/courseCenter/resources.js';

import { gradeStrList, courseLevelStrList } from '@/utils/dictionary.js';
import { quelityTypeList, hostingTypeList } from '@/utils/dictionary';
import ChooseApply from '@c/searchBlock/ChooseApply.vue';

export default {
  components: {
    ChooseAndModal,
    ChooseApply

  },
  props: {
    schoolId: {
      type: String,
      default: ''
    },
    yearTerms: {
      type: Array,
      default: ''
    },
    yearTermStr: {
      type: String,
      default: ''
    },
    classType: {
      type: [Number, Object],
      default: null
    }
  },
  data() {
    return {
      show: false,
      courseSearchData: {
        classroomName: '',
        orgId: '',
        classType: ''

      },
      selectCourseList: [], // 选中的课程
      rightColumns: [
        {
          title: '课程商品名',
          key: 'classroomName'
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ], //
      trainingType: '',
      termList: [],
      loadingApply: false,
      applyList: [],
      courseType: {
        11: '艺术',
        12: '科技',
        13: '体育',
        14: '美术',
        15: '综合实践',
        21: '早托',
        22: '午托',
        23: '晚托',
        24: '全托'
      },
      courseTypeList: [
        {
          name: '素质课',
          id: 1
        },
        {
          name: '基础托管',
          id: 2
        }
      ], // 课程类别
      courseListColumn: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '课程商品名',
          key: 'classroomName',
          fixed: 'left',
          minWidth: 230
        },
        {
          title: '上课时间',
          key: 'timeDesc',
          minWidth: 238
        },
        {
          title: '价格（元）',
          key: 'classroomFee',
          width: 120,
          fixed: 'left',
          render: (h, params) => {
            return h('div', [
              params.row.classroomFee
                ? Number(params.row.classroomFee) / 100
                : ''
            ]);
          }
        },
        {
          title: '提供方',
          key: 'orgName',
          minWidth: 250
        },
        {
          title: '类别',
          key: 'courseTypeKind',
          width: 120,
          render: (h, params) => {
            return h('div', [
              params.row.courseTypeKind
                ? this.courseType[params.row.courseTypeKind]
                : ''
            ]);
          }
        },
        {
          title: '学期',
          key: 'termName',
          width: 200
        },
        {
          title: '已报人数',
          key: 'registeredNumbers',
          width: 100
        }
      ], // 课程商品表格column
      courseGoodsList: [], // 课程商品列表
      coursePageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      portOrg: Number(localStorage.getItem('portOrg')),
      tableLoading: false
    };
  },
  watch: {
    classType(newVal) {
      this.courseSearchData.classType = newVal;
      console.log(newVal, 'newVal');
    }
  },

  created() { },
  mounted() { },
  methods: {
    init() {
      this.coursePageInfo = {
        total: 0,
        pageSize: 10,
        pageNum: 1
      };
      this.courseGoodsList = [];
      //  this.getApplyList()
      this.getYearTerm();

      this.getCourseList();
    },
    open(productList) {
      this.show = true;
      this.selectCourseList = productList;
      this.init();
    },
    handleCancleBtn() {
      this.show = false;
    },
    // 提交
    handleSureBtn() {
      // if (this.selectCourseList.length < 2) {
      //   this.$Message.error('至少选择2门课程商品');
      //   return null;
      // }
      this.show = false;
      this.$emit('on-finish', this.selectCourseList);
    },

    getSelectCourseRow(row) {
      console.log(row);
    },
    handlePageChange(page) {
      this.coursePageInfo.pageNum = page;
      this.getCourseList();
    },
    handleOnApplyChange(val) {
      this.courseSearchData.orgId = val.orgId;
    },

    // 获取商品课程列表
    async getCourseList() {
      const params = {
        schoolId: this.schoolId,
        pageNum: this.coursePageInfo.pageNum,
        pageSize: this.coursePageInfo.pageSize
      };
      const paramsTrue = Object.assign(params, this.courseSearchData);
      if (this.yearTerms.length === 2) {
        paramsTrue.yearCode = this.yearTerms[0];
        paramsTrue.termCode = this.yearTerms[1];
      }
      let res;
      //
      this.tableLoading = true;

      res = await courseCenter.getgoodsTableList(paramsTrue);

      this.tableLoading = false;
      if (res.status === 200 && res.message.list) {
        this.courseGoodsList = res.message.list.map(item => {
          // item.classTimeShow = dealTimeList(item);
          item.id = item.classroomId;
          return item;
        });
        this.coursePageInfo.total = Number(res.message.total);
        this.handleCourseGoodsList();
      } else if (res.status === 200 && !res.message.list) {
        this.courseGoodsList = [];
        this.coursePageInfo.total = Number(res.message.total);
        this.handleCourseGoodsList();
      }
    },
    handleGetSearchValue() {
      this.coursePageInfo.pageNum = 1;
      this.coursePageInfo.total = 0;
      this.getCourseList();
    },
    handleResetSearch() {
      this.$refs.chooseApplyRef && this.$refs.chooseApplyRef.handleClear();
      this.courseSearchData.classroomName = '';
      this.$nextTick(() => {
        this.handleGetSearchValue();
      });
      // this.courseSearchData = {
      //   courseName: '',
      //   orgId: '',
      //   // classType: '',
      //   termId: ''
      // };
    },
    onSelectionChange(selection, row) { },
    onSelectCancel(selection, row) {
      const key = this.selectCourseList.findIndex(item => {
        return item.classroomId == row.classroomId;
      });
      if (key != -1) {
        this.selectCourseList.splice(key, 1);
      }
    },
    onSelectAll(selection) {
      selection.forEach(item => {
        this.onSelect(selection, item);
      });
    },
    onSelectAllCancel(selection) {
      this.courseGoodsList.forEach(item => {
        this.onSelectCancel(selection, item);
      });
    },
    onSelect(selection, row) {
      const key = this.selectCourseList.findIndex(item => {
        return item.classroomId == row.classroomId;
      });
      if (key == -1) {
        this.selectCourseList.push(row);
      }
    },
    // 删除
    handleRemove(row, index) {
      this.selectCourseList.splice(index, 1);
      this.handleCourseGoodsList();
    },
    // 处理列表选中效果
    handleCourseGoodsList() {
      this.courseGoodsList.forEach(item => {
        item._checked = false;
        const key = this.selectCourseList.findIndex(item_1 => {
          return item_1.classroomId == item.classroomId;
        });
        if (key != -1) {
          item._checked = true;
        }
      });
      this.courseGoodsList = Object.assign([], this.courseGoodsList);
    },
    async getYearTerm(orgId) {
      const res = await courseCenter.getListTerms({
        orgId: this.schoolId,
        termState: 1
      });
      if (res.status == 200) {
        this.termList = res.message;
      }
    }

  }
};
</script>

<style lang="scss" scoped>
.search-line {
  margin-bottom: 16px;
  display: flex;
  .search-input {
    width: 160px;
    margin-right: 16px;
  }
  .search-select {
    width: 250px;
    margin-right: 16px;
  }
}
.iconTips {
  display: flex;
  align-items: center;
  padding-left: 20px;
  margin: 0 0 10px 10px;
  width: 600px;
  height: 30px;
  background-color: #fffae2;
  border: solid 1px #ffe184;
}
.page-main {
  text-align: right;
  padding: 16px 0;
}
.flex {
  display: flex;
  .left {
    width: 70%;
    margin-right: 20px;
  }
  .right {
    width: 28%;
    .head {
      background: rgba(0, 0, 0, 0.05);
      padding: 8px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
    }
  }
}
.modal-footer {
  text-align: right;
  padding: 10px 0;
}
</style>
